import { render } from "./GroomHorses.vue?vue&type=template&id=c22bf5c2"
import script from "./GroomHorses.vue?vue&type=script&lang=js"
export * from "./GroomHorses.vue?vue&type=script&lang=js"

import exportComponent from "/Users/iomac/Progetti/equiup/equiupmaneggi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__